import { StreamOperation } from '@injectivelabs/ts-types'
import {
  streamHistoricalStaking as grpcStreamHistoricalStaking,
  streamStakingRewardByAccount as grpcStreamStakingRewardByAccount
} from '@/app/client/streams/staking'
import { STAKING_CONTRACT_ADDRESS } from '@/app/utils/constant'
import { EventBus } from '@/types'

export const streamStakingActivities = () => {
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.injectiveAddress) {
    return
  }

  grpcStreamHistoricalStaking({
    staker: sharedWalletStore.injectiveAddress,
    stakingContractAddress: STAKING_CONTRACT_ADDRESS,
    callback: ({ historicalStaking }) => {
      if (!historicalStaking) {
        return
      }

      useEventBus(EventBus.StreamHistoricalStakingUpdate).emit()
    }
  })
}

export const streamStakingReward = () => {
  const stakingStore = useStakingStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.injectiveAddress) {
    return
  }

  grpcStreamStakingRewardByAccount({
    staker: sharedWalletStore.injectiveAddress,
    stakingContractAddress: STAKING_CONTRACT_ADDRESS,
    callback: ({ stakingReward, opType }) => {
      if (!stakingReward) {
        return
      }

      switch (opType) {
        case StreamOperation.Insert: {
          stakingStore.$patch({
            stakingRewards: [stakingReward, ...stakingStore.stakingRewards]
          })

          break
        }
        case StreamOperation.Update: {
          stakingStore.$patch({
            stakingRewards: [
              stakingReward,
              ...stakingStore.stakingRewards.filter(
                (r) => r.vaultAddress !== stakingReward.vaultAddress
              )
            ]
          })

          break
        }
      }
    }
  })
}
